export var USER_REGISTERED;

(function (USER_REGISTERED) {
  USER_REGISTERED["USER_REGISTERED"] = "USER_REGISTERED";
  USER_REGISTERED["USER_NOT_REGISTERED"] = "USER_NOT_REGISTERED";
})(USER_REGISTERED || (USER_REGISTERED = {}));

export var USER_META_KEYS;

(function (USER_META_KEYS) {
  USER_META_KEYS["INITIAL_ONBOARDING"] = "INITIAL_ONBOARDING";
  USER_META_KEYS["SURVEY"] = "SURVEY";
  USER_META_KEYS["SUPPORT_CRUSHER"] = "SUPPORT_CRUSHER";
  USER_META_KEYS["SELECTED_PROJECT_ID"] = "appState.SELECTED_PROJECT_ID";
  USER_META_KEYS["LAST_VISITED_URL"] = "appState.LAST_VISITED_URL";
  USER_META_KEYS["TEST_CREATED"] = "TEST_CREATED";
  USER_META_KEYS["RAN_TEST"] = "RAN_TEST";
  USER_META_KEYS["VIEW_REPORT"] = "VIEW_REPORT";
})(USER_META_KEYS || (USER_META_KEYS = {}));

export var TEAM_META_KEYS;

(function (TEAM_META_KEYS) {
  TEAM_META_KEYS["TEST_CREATED"] = "TEST_CREATED";
})(TEAM_META_KEYS || (TEAM_META_KEYS = {}));

export var PROJECT_META_KEYS;

(function (PROJECT_META_KEYS) {
  PROJECT_META_KEYS["TEST_CREATED"] = "TEST_CREATED";
  PROJECT_META_KEYS["RAN_TEST"] = "RAN_TEST";
  PROJECT_META_KEYS["VIEW_REPORT"] = "VIEW_REPORT";
  PROJECT_META_KEYS["INTEGRATE_WITH_CI"] = "INTEGRATE_WITH_CI";
})(PROJECT_META_KEYS || (PROJECT_META_KEYS = {}));